import axios from 'axios'
import { makeQueryString } from '@/utils/Query.js'
const API_BASE_URL = process.env.VUE_APP_API_URL;

const config = {
    baseUrl: API_BASE_URL + "/homepage/investors/"
};

const investorsAPIDFN = {
    investorsAPI: (APIName, conditions, paths) => {
        return investorsAPI[APIName](conditions, paths);
    }
};

const investorsAPI = {
    API_BASE_URL: `${API_BASE_URL}`,
    selectFinancialData: (conditions, paths) => {
        const uri = paths || "investors/selectFinancialData"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getFinancialData: (conditions, paths) => {
        const uri = paths || "investors/getFinancialData"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectDisclosureData: (conditions, paths) => {
        const uri = paths || "investors/selectDisclosureData"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getDisclosureData: (conditions, paths) => {
        const uri = paths || "investors/getDisclosureData"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectIrData: (conditions, paths) => {
        const uri = paths || "investors/selectIrData"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getIrData: (conditions, paths) => {
        const uri = paths || "investors/getIrData"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
};

export { investorsAPIDFN, investorsAPI };
